(function () {
  if (window.__pbRibrowInit) return;
  window.__pbRibrowInit = true;

  var PB_VARIANT  = 57171099287887;
  var PB_DISCOUNT = 'Ribrow30';
  var HEADERS = { 'Content-Type': 'application/json', 'Accept': 'application/json' };

  function pbGetCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function pbSetDiscounts(codes) {
    return fetch('/cart/update.js', {
      method: 'POST', headers: HEADERS,
      body: JSON.stringify({ discount: codes.join(',') })
    });
  }

  function pbNotifyTheme() {
    return pbGetCart().then(function (cart) {
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: 'pb-ribrow-upsell',
          data: { source: 'pb-ribrow-upsell', itemCount: cart.item_count }
        }
      }));
    });
  }

  document.addEventListener('change', async function (e) {
    var check = e.target.closest('.pb-ribrow-check');
    if (!check) return;

    var wrap = check.closest('[data-pb-ribrow]');
    if (!wrap) return;
    wrap.classList.add('is-loading');

    try {
      if (check.checked) {
        await fetch('/cart/add.js', {
          method: 'POST', headers: HEADERS,
          body: JSON.stringify({ items: [{ id: PB_VARIANT, quantity: 1 }] })
        });
        var cart = await pbGetCart();
        var codes = (cart.discount_codes || []).map(function (d) { return d.code; });
        if (codes.indexOf(PB_DISCOUNT) === -1) codes.push(PB_DISCOUNT);
        await pbSetDiscounts(codes);
      } else {
        // rileggo la line key a runtime: dopo un re-render dataset.lineKey può essere stale/vuota
        var key = wrap.dataset.lineKey;
        if (!key) {
          var c0 = await pbGetCart();
          var item = (c0.items || []).find(function (i) { return i.variant_id === PB_VARIANT; });
          if (item) key = item.key;
        }
        if (key) {
          await fetch('/cart/change.js', {
            method: 'POST', headers: HEADERS,
            body: JSON.stringify({ id: key, quantity: 0 })
          });
        }
        var cart2 = await pbGetCart();
        var remaining = (cart2.discount_codes || [])
          .map(function (d) { return d.code; })
          .filter(function (c) { return c.toLowerCase() !== PB_DISCOUNT.toLowerCase(); });
        await pbSetDiscounts(remaining);
      }
      await pbNotifyTheme();
    } catch (err) {
      console.error('[PB Ribrow upsell]', err);
      check.checked = !check.checked; // rollback visivo
    } finally {
      wrap.classList.remove('is-loading'); // sempre, anche in caso di errore
    }
  });
})();